import EventEmitter from "./utils/EventEmitter";

export default class Menu extends EventEmitter {
    constructor(element) {
        super();
        this.el = element

        this.isSearchPage = document.querySelector('.search-page')

        this.topNavItems = Array.from(this.el.querySelectorAll('.main-menu .nav-item'))
        this.topNavLinks = Array.from(this.el.querySelectorAll('.main-menu .nav-link'))
        this.searchIcon = this.el.querySelector('.search-field')
        this.subMenusContainer = this.el.querySelector('.sub-menus-container')
        this.subMenus = Array.from(this.el.querySelectorAll('.sub-menu'))
        this.lastPublication = this.el.querySelector('.block-last-publication')


        // The search menu is optional: never rely on HTML ids here, they can get
        // a "--N" suffix (e.g. "edit-search--2") depending on the page.
        this.searchMenu = document.querySelector('.main-search-menu')
        this.searchSuggestionTarget = this.searchMenu?.querySelector('.search-suggestion-target')
        this.form = this.searchMenu?.querySelector('form')
        this.searchInput = this.form?.querySelector('input[name="search"]')
        this.totalResultsButton = this.searchMenu?.querySelector('.results-button')
        this.totalResultsText = this.totalResultsButton?.querySelector('.results')

        this.searchSuggestionsContainer = document.querySelector('.search-suggestions-container')
        this.globalSuggestions = document.querySelector('.global-suggestions')

        this.userMenuContainer = this.el.querySelector('.user-menu-container')

        if (this.userMenuContainer) {
            this.userSubMenu = this.userMenuContainer.querySelector('.user-sub-menu')
            this.userMenuBtn = this.userMenuContainer.querySelector('.user-menu-btn')
        }

        this.states = {
            expanded: false
        }

        this.events()

        setTimeout(() => {
            this.searchAPIResults = document.querySelector('.search-api-autocomplete-search')

            if (!this.searchSuggestionTarget) {
                return
            }

            // Move the search suggestions wrapper to the search menu
            if (this.searchAPIResults) {
                this.searchSuggestionTarget.appendChild(this.searchAPIResults)
            }

            this.createSearchMutationObserver()

        }, 200)
    }

    events() {
        this.topNavLinks.forEach((link) => {
            link.addEventListener('click', (e) => {e.preventDefault()})
        })

        this.topNavItems.forEach((item, index) => {
            item.addEventListener('mouseenter', () => {
                if (!this.isSearchPage) {
                    this.closeSearchMenu()
                }
                this.expandSubMenu(index)
            });
        });

        this.el.addEventListener('mouseleave', () => {
            if (this.states.expanded) {
                this.closeSubMenu()
            }
        })

        if (!this.isSearchPage && this.searchIcon && this.searchMenu) {
            this.searchIcon.addEventListener('click', () => {
                this.closeSubMenu()
                this.expandSearchMenu()
            })
        }

        if (this.searchMenu) {
            this.searchMenu.addEventListener('mouseleave', () => {
                if (!this.isSearchPage) {
                    this.closeSearchMenu()
                }
            })
        }

        // Si le search input est vide, on cache les suggestions
        if (this.searchInput) {
            this.searchInput.addEventListener('input', (e) => {
                // Si à moins de 3 caractères, on cache les suggestions
                if (e.target.value.length < 3) {
                    this.searchSuggestionsContainer?.classList.remove('visible')
                    this.totalResultsButton?.classList.remove('active')
                    this.globalSuggestions?.classList.add('visible')

                    setTimeout(() => {
                        this.updateSearchMenuHeight()
                    }, 50)
                }
            })
        }

        if (this.totalResultsButton && this.form) {
            this.totalResultsButton.addEventListener('click', () => {
                this.form.submit()
            })
        }

        if (this.userMenuContainer) {
            this.userMenuBtn.addEventListener('mouseenter', () => {
                this.userSubMenu.classList.add('expanded')
            })

            // Si on clique ailleurs on ferme le menu
            document.addEventListener('click', (e) => {
                if (!this.userMenuContainer.contains(e.target)) {
                    this.userSubMenu.classList.remove('expanded')
                }
            })
        }
    }

    createSearchMutationObserver() {
        const observer = new MutationObserver(this.onMutation.bind(this))

        observer.observe(this.searchSuggestionTarget, {
            childList: true,
            subtree: true
        })
    }

    onMutation(mutations, observer) {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length > 0) {
                this.searchSuggestionsContainer?.classList.add('visible')
                this.globalSuggestions?.classList.remove('visible')

                this.updateNumberResults()

                setTimeout(() => {
                    this.updateSearchMenuHeight()
                }, 50)
            }
        })
    }

    updateNumberResults() {
        if (!this.totalResultsButton || !this.totalResultsText) {
            return
        }

        if (this.searchSuggestionTarget.querySelector('.autocomplete-suggestion-label')) {
            this.totalResultsText.innerText = this.searchSuggestionTarget.querySelector('.autocomplete-suggestion-label').innerText
            this.totalResultsButton.classList.add('active')
        } else {
            this.totalResultsButton.classList.remove('active')
        }

    }

    expandSubMenu(index) {
        document.querySelector('body').classList.add('overlay-on')
        this.states.expanded = true;
        this.el.classList.remove((index === 2) ? 'bck-green-dark' : 'bck-blue4');
        this.el.classList.add((index === 2) ? 'bck-blue4' : 'bck-green-dark');

        if (this.lastPublication) {
            if (index === 0) {
                this.lastPublication.classList.add('expanded')
            } else {
                this.lastPublication.classList.remove('expanded')
            }
        }

        if (!this.subMenus[index] || !this.subMenusContainer) {
            return
        }

        const subMenuHeight = this.subMenus[index].offsetHeight

        this.subMenus.forEach((subMenu) => {
            subMenu.classList.remove('expanded')
        })

        this.subMenus[index].classList.add('expanded')
        this.subMenusContainer.style.height = `${subMenuHeight}px`
    }

    expandSearchMenu() {
        if (!this.searchMenu) {
            return
        }

        document.querySelector('body').classList.add('overlay-on')
        this.el.classList.remove('bck-blue4');
        this.el.classList.add('bck-green-dark');
        this.searchMenu.classList.add('expanded')
        this.searchMenu.style.height = `${this.searchMenu.scrollHeight}px`
    }

    updateSearchMenuHeight() {
        if (!this.searchMenu) {
            return
        }

        this.searchMenu.style.height = 'auto'
        this.searchMenu.style.height = `${this.searchMenu.scrollHeight}px`
    }

    closeSearchMenu() {
        this.el.classList.remove('bck-green-dark');
        if (this.searchMenu) {
            this.searchMenu.classList.remove('expanded')
            this.searchMenu.style.height = 0
        }
        document.querySelector('body').classList.remove('overlay-on')
    }

    closeSubMenu() {
        this.el.classList.remove('bck-blue4', 'bck-green-dark')
        if (this.lastPublication)
            this.lastPublication.classList.remove('expanded')
        this.states.expanded = false

        if (this.subMenusContainer) {
            this.subMenusContainer.style.height = 0
        }
        this.subMenus.forEach((subMenu) => {
            subMenu.classList.remove('expanded')
        })

        if (this.searchMenu && this.searchMenu.classList.contains('expanded')) {
            this.searchMenu.classList.remove('expanded')
            if (!this.isSearchPage) {
                this.closeSearchMenu()
            }
        }

        document.querySelector('body').classList.remove('overlay-on')
    }
}
